import { useEffect, useRef, useState } from "react";
import { NPayModalWrapper } from "../products/detail/ProductDetails-styles";
import { useRouter } from "next/router";
import { StoreOrderApi } from "../../api/order";
import { failAlert } from "../../common/alert";
import { connect } from "react-redux";
import {
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
} from "../../redux/action/confirm";
import { isLoaded, isLoading } from "../../redux/action/loading";
import { favoritesApi } from "../../api/favorites";
import { getCookie } from "../../common/auth";
import getUserAgent from "../../common/util/getUserAgent";
import Image from "next/image";

const PaymentNaverPay = ({
  product,
  cnt,
  loading,
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
  isLoaded,
  isLoading,
  userDevice,
}) => {
  const router = useRouter();
  const ref = useRef();
  const [isUser, setIsUser] = useState(false);
  const [selectModal, setSelectModal] = useState(false);

  const naverpayCheckout = async () => {
    isLoading();
    try {
      const body = {
        modes: "OrderTemp",
        naverYn: "Y",
        items: JSON.stringify([{ pcode: product.pcode, cnt }]),
        flowCode: getCookie("NA_CO"),
        clickId: getCookie("NVADID"),
        slog: sessionStorage.getItem("slog") || "",
        usepoint: 0,
        coupon_code: "",
        mobileYn: userDevice === "mobile" ? "Y" : "N",
      };
      const res = await StoreOrderApi(body);
      if (res.Code === "0000") {
        const UserAgent = getUserAgent();
        const widerplanet_device =
          UserAgent.match(
            /iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i
          ) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null
            ? "mobile"
            : "web";
        if (widerplanet_device === "web") {
          window.open(
            `https://order.pay.naver.com/customer/buy/${res?.Data?.sertParam}`
          );
        }
        if (widerplanet_device === "mobile") {
          router.push(
            `https://m.pay.naver.com/o/customer/buy/${res?.Data?.sertParam}`
          );
        }
        isLoaded();
      } else {
        isLoaded();
        failAlert(res?.Data?.Msg);
      }
    } catch (error) {
      isLoaded();
      alert(error.message);
    }
    isLoaded();
  };

  const naverpayZzim = async () => {
    isLoading();

    try {
      const body = {
        modes: "NaverInsertSet",
        pcode: product.pcode,
      };
      const res = await favoritesApi(body);
      if (res.Code == "0000") {
        if (res.Data?.Data.includes("<html>")) {
          return alert("찜하기에 문제가 발생했습니다.");
        }
        const UserAgent = getUserAgent();
        const widerplanet_device =
          UserAgent.match(
            /iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i
          ) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null
            ? "mobile"
            : "web";
        if (widerplanet_device === "web") {
          globalThis.open(
            `https://pay.naver.com/customer/wishlistPopup.nhn?SHOP_ID=${process.env.NEXT_PUBLIC_NAVER_PAY_ID}&ITEM_ID=${res.Data?.Data}`,
            "_blank",
            "width=800,height=600"
          );
        }
        if (widerplanet_device === "mobile") {
          router.push(
            `https://m.pay.naver.com/mobile/customer/wishList.nhn?SHOP_ID=${process.env.NEXT_PUBLIC_NAVER_PAY_ID}&ITEM_ID=${res.Data?.Data}`
          );
        }
        isLoaded();
      }
    } catch (error) {
      alert(error.message);
      isLoaded();
    }
  };

  useEffect(() => {
    if (getCookie("token")) {
      setIsUser(true);
    } else {
      setIsUser(false);
    }
  }, []);

  return (
    <>
      <div className="d-flex justify-content-end">
        <div className="social-payment">
          <div
            className="naver-btn"
            onClick={() => setSelectModal(true)}
            style={{ position: "relative" }}
          >
            <img
              src="/assets/imgs/product/payment_icon_naver.png"
              alt="네이버페이 구매"
            />
            구매
          </div>
          <div className="pick" onClick={naverpayZzim}>
            찜
          </div>
        </div>
      </div>
      {selectModal && (
        <NPayModalWrapper>
          <div className="modal-section">
            <div className="modal-content">
              <div className="desc">
                <figure>
                  <Image
                    src="https://file.caretbio.com/caretbio/318411ad02c715642b18a63832b43268.png"
                    alt="naver_pay_info"
                    width={613}
                    height={359}
                  />
                </figure>
                <p>
                  회원가입 후 칼렛스토어 구매를 선택하시면
                  <br /> 최대 5만원 쿠폰 사용과 포인트 적립 및 사용이 가능합니다
                  <br />
                  *Npay 로 결제시 상기 혜택은 적용되지 않습니다
                </p>
              </div>
              <div className="btnWrapper">
                <span className="cancel" onClick={() => setSelectModal(false)}>
                  칼렛스토어 구매
                </span>
                <span className="confirm" onClick={() => naverpayCheckout()}>
                  <img
                    src="/assets/imgs/product/payment_icon_naver.png"
                    alt="네이버페이 구매"
                  />
                  구매
                </span>
              </div>
            </div>
          </div>
        </NPayModalWrapper>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  loading: state.loading.loading,
});

const mapDispatchToProps = {
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
  isLoaded,
  isLoading,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentNaverPay);
